/* eslint-disable import/prefer-default-export */
export const formatToFixed = (num, toFixedNum) =>
  typeof num === 'number' ? num.toFixed(toFixedNum) : num;
